import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CategoryService} from '@app/services/category.service';
import {HttpUrlEncodingCodec} from '@angular/common/http';
import {Router} from '@angular/router';
import {Category} from '@spartacus/core';

@Component({
  selector: 'dcp-categories-menu',
  templateUrl: './categories-menu.component.html',
  styleUrls: ['./categories-menu.component.scss']
})

export class CategoriesMenuComponent implements OnInit {
  @Input() modal: NgbActiveModal;

  categories: Array<Category>;
  selectedCategory: Category;
  queryCodec: HttpUrlEncodingCodec;

  constructor(public categoryService: CategoryService, private router: Router) {
    this.queryCodec = new HttpUrlEncodingCodec();
  }

  ngOnInit() {
    this.initSelectedCategory();
    this.categories = this.categoryService.getCategories();
  }

  initSelectedCategory(): void {
    this.selectedCategory = {
      translationKey: '',
      subCategories: [],
      selected: false,
    };
  }

  showSubCategories(category: Category): void {
    this.selectedCategory = {
      translationKey: category.translationKey,
      subCategories: category.subCategories,
      selected: true,
    };
  }

  redirectToUrl(url: string) {
    const modalMessage: string = 'Selected browse all category';
    this.router.navigateByUrl(url);
    this.modal.dismiss(modalMessage);
  }

  hideSubCategories(): void {
    this.initSelectedCategory();
  }
}
